import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import { GetKey } from "../../Finanzas/Actions/GetContainer";
import { useBox } from "../../Finanzas/Helper/useBox";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import FiltroMensajeriaPostventa from "./FiltroMensajeriaPostventa";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";
import { GetMonthNameByNumber } from "../../Finanzas/Helper/GetMonthNameByNumber";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AgregarContactoCotizacionesModal from "../Dashboard/Cotizaciones/AgregarContactoCotizacionesModal";
import AgregarContactoModal from "../Dashboard/Cotizaciones/AgregarContactoModal";
import AgregarContactoModalS from "../Dashboard/Mantenimiento/AgregarContactoModal";



export const MensajeriaGeneralScreen = () => {
    const history = useHistory();
    const [boxstate, setBoxState] = useBox();
    const [mensajeria, setMensajeria] = useState();
    const [titulo, setTitulo] = useState('MENSAJERIA GENERAL');
    const [motivoSeleccionado, setMotivoSeleccionado] = useState("");
    const [mostrar, setMostrar] = useState();
    const [options, setOptions] = useState([]);
    const [primerMostrar, setPrimerMostrar] = useState("");

    const [clienteSelect, setClienteSelect] = useState();
    const [folioSelect, setFolioSelect] = useState();
    const [idGarantia, setIdGarantia] = useState(0);
    const [registroSelect, setRegistroSelect] = useState();

    const [openModalContactoC, setOpenModalContactoC] = useState(false);
    const [openModalContactoG, setOpenModalContactoG] = useState(false);
    const [openModalContactoS, setOpenModalContactoS] = useState(false);


    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const onRegresar = () => {
        history.push("/Postventa/Main");
    };

    useEffect(() => {
        if (mostrar === "S") {
            setOptions([
                { value: "", label: "Consolidado" },
                { value: "PS", label: "Precio del servicio" },
                { value: "DC", label: "Disponibilidad de crédito" },
                { value: "AB", label: "Atención brindada" },
                { value: "NN", label: "No se necesitó" }
            ]);
        } else if (mostrar === "C") {
            setOptions([
                { value: "", label: "Consolidado" },
                { value: "TE", label: "Tiempo de entrega" },
                { value: "PR", label: "Precio de refacción" },
                { value: "AB", label: "Atención brindada" },
                { value: "NN", label: "No se necesitó" }
            ]);
        } else {
            setOptions([]); // si mostrar no es S o C, no hay selector
        }
    }, [mostrar]);

    useEffect(() => {
        if (!primerMostrar) return;
        const today = new Date();
        const currentMonth = today.getMonth() + 1;
        const currentYear = today.getFullYear();
        onExecute(currentYear, currentYear, currentMonth, currentMonth, primerMostrar, 'CC', 'CC');
    }, [primerMostrar]);

    const onExecute = (
        ejercicio_inicio,
        ejercicio_fin,
        periodo_inicio,
        periodo_fin,
        mostrar,
        interes,
        motivo,
    ) => {
        setLoader({ ...loader, mostrar: true });
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        var p_fin = "";
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        if (
            periodo_fin === undefined ||
            periodo_fin === null ||
            periodo_fin === "" ||
            periodo_fin === "0"
        ) {
            p_fin = periodo_inicio;
        } else {
            p_fin = periodo_fin;
        }

        if (parseInt(periodo_fin) < parseInt(periodo_inicio)) {
            Swal.fire(
                "MENSAJERIA",
                "La fecha de inicio no puede ser menor a la final",
                "warning"
            );
            setLoader({ ...loader, mostrar: false });
            return;
        }

        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `MensajeriaGeneral/ObtenerMensajeria?ejercicio_inicio=${ejercicio_inicio}&ejercicio_fin=${ejercicio_fin}&periodo_inicio=${periodo_inicio}&periodo_fin=${periodo_fin}&adr=${adr}&sucursal=${sucursales}&mostrar=${mostrar}&interes=${interes}&motivo=${'CC'}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setMostrar(mostrar);
                    const mesInicio = GetMonthNameByNumber(periodo_inicio).toUpperCase();
                    const mesFin = GetMonthNameByNumber(periodo_fin).toUpperCase();
                    const tituloPeriodo = periodo_inicio === periodo_fin
                        ? `${mesInicio} ${ejercicio_inicio}`
                        : `${mesInicio} - ${mesFin} ${ejercicio_inicio}`;
                    // console.log(tituloPeriodo)

                    let tituloBase = "";
                    if (mostrar === "S") tituloBase = "MENSAJERÍA SERVICIOS";
                    else if (mostrar === "C") tituloBase = "MENSAJERÍA COTIZACIONES";
                    else if (mostrar === "G") tituloBase = "MENSAJERÍA GARANTÍAS";

                    // Siempre agregar periodo y ejercicio
                    const tituloCompleto = `${tituloBase} ${tituloPeriodo}`;
                    setTitulo(tituloCompleto);

                    setTitulo(tituloCompleto);
                    setMensajeria(result);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };


    const onActualizar = () => {
        const today = new Date();
        const currentMonth = today.getMonth() + 1;
        const currentYear = today.getFullYear();

        onExecute(currentYear, currentYear, currentMonth, currentMonth, mostrar, 'CC', 'CC');
    }
    const handleOpenModalContacto = (idcliente, folio, id_garantia, registroSelect) => {
        if (!idcliente) {
            idcliente = -99
        }
        setClienteSelect(idcliente);
        setFolioSelect(folio);
        setIdGarantia(id_garantia)
        setRegistroSelect(registroSelect)

        if (mostrar === "C") {
            setOpenModalContactoC(true);
        }
        else if (mostrar === "G") {
            setOpenModalContactoG(true);
        }
        else if (mostrar === "S") {
            setOpenModalContactoS(true);
        }
    };

    const handleCloseModalContacto = () => {
        setClienteSelect("");
        setFolioSelect("");

        if (mostrar === "C") {
            setOpenModalContactoC(false);
        }
        else if (mostrar === "G") {
            setOpenModalContactoG(false);
        }
        else if (mostrar === "S") {
            setOpenModalContactoS(false);
        }

    };


    const agruparPorInteres = (data, mostrar) => {
        if (!data) return [];

        if (mostrar === "G") {
            const grupos = { CI: [], SI: [], ER: [], RL: [] };
            data.forEach((item) => {
                if (item.estatus === "CI") grupos.CI.push(item);
                else if (item.estatus === "SI") grupos.SI.push(item);
                else if (item.estatus === "ER") grupos.ER.push(item);
                else if (item.estatus === "RL") grupos.RL.push(item);
            });

            const orden = [
                { key: "CI", titulo: "Clientes con interés" },
                { key: "SI", titulo: "Clientes sin interés" },
                { key: "RL", titulo: "Respuesta escrita" },
                { key: "ER", titulo: "Esperando Respuesta" }
            ];

            return orden
                .filter((g) => grupos[g.key].length > 0)
                .map((g) => ({
                    grupo: g.titulo,
                    registros: grupos[g.key],
                }));
        }

        // ---- lógica normal para S y C ----
        const gruposMap = { CI: [], SI: [], ER: [], RL: [] };
        data.forEach((item) => {
            if (mostrar === "C") {
                if (item.tipo === "CI") gruposMap.CI.push(item);
                else if (item.tipo === "ER") gruposMap.ER.push(item);
                else if (item.tipo === "RL") gruposMap.RL.push(item);
                else gruposMap.SI.push(item); // todos los demás van a SI
            } else {
                if (item.estado === "CI") gruposMap.CI.push(item);
                else if (item.estado === "ER") gruposMap.ER.push(item);
                else if (item.estado.substring(0, 2) === "RL") gruposMap.RL.push(item);
                else if (item.estado === "SI") gruposMap.SI.push(item);
            }
        });

        const orden = [
            { key: "CI", titulo: "Clientes con interés" },
            { key: "SI", titulo: "Clientes sin interés" },
            { key: "RL", titulo: "Respuesta escrita" },
            { key: "ER", titulo: "Esperando respuesta" }
        ];
        return orden
            .filter((g) => gruposMap[g.key].length > 0)
            .map((g) => ({
                grupo: g.titulo,
                registros: gruposMap[g.key],
            }));
    };
    // console.log(primerMostrar)
    return (
        <PlantillaScreen
            titulo={titulo}
            className={"mensajeria-postventa-main-screen"}
            className_main={2}
        >
            <AgregarContactoCotizacionesModal
                open={openModalContactoC}
                onClose={handleCloseModalContacto}
                idcliente={clienteSelect}
                folio={folioSelect}
                update={onActualizar}
            />
            <AgregarContactoModal
                open={openModalContactoG}
                onClose={handleCloseModalContacto}
                idcliente={clienteSelect}
                idGarantia={idGarantia}
                update={onActualizar}
            />
            <AgregarContactoModalS
                open={openModalContactoS}
                onClose={handleCloseModalContacto}
                idRegistro={registroSelect}
                update={onActualizar}
            />
            <LoaderScreen loader={loader} />
            <div className="mensajeria-postventa-actions">
                <div
                    className="mensajeria-postventa-actions-regresar"
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="mensajeria-postventa-actions-filtro">
                    <FiltroMensajeriaPostventa
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                        mostrarinteres={true}
                        mostrarmotivo={false}
                        mostrarselector={true}
                        handlePrimerMostrar={(valor) => setPrimerMostrar(valor)}
                    />
                </div>
            </div>
            <div className="contador-mensajeria-postventa-encontrados">
                Mensajes enviados: {mensajeria?.length}
            </div>
            {mensajeria && mensajeria.length > 0 && mostrar && (
                <div className="mensajeria-postventa">
                    <div className="mensajeria-postventa-container scroll">
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <th>
                                        {mostrar === "C"
                                            ? "Folio"
                                            : mostrar === "S"
                                                ? "ID Registro"
                                                : "ID Garantía"}
                                    </th>
                                    <th><div>Sucursal</div></th>
                                    {(mostrar === "C") && (
                                        <th><div>ID Cliente</div></th>
                                    )}
                                    <th><div>Cliente</div></th>
                                    <th><div>Contacto</div></th>

                                    {mostrar === "C" ? (
                                        <th><div>Vendedor</div></th>
                                    ) : (
                                        <>
                                            <th><div>N. Serie</div></th>
                                            <th><div>Modelo</div></th>
                                        </>
                                    )}
                                    {(mostrar === "C" || mostrar === "S") && (
                                        <th><div>Fecha de envío</div></th>
                                    )}
                                    <th><div>Estado</div></th>
                                    {(mostrar === "S" || mostrar === "C") && (
                                        <th><div>Motivo</div></th>
                                    )}
                                    <th><div>Facturado</div></th>
                                </tr>
                            </thead>
                            <tbody>
                                {agruparPorInteres(mensajeria, mostrar).map((grupo, i) => (
                                    <React.Fragment key={i}>
                                        {/* Fila de agrupamiento */}
                                        <tr className="grupo-row">
                                            <td colSpan={mostrar === "S" ? 11 : 10} className="grupo-header">
                                                {grupo.grupo === "Clientes sin interés" && (mostrar === "S" || mostrar === "C") ? (
                                                    <div className="grupo-header-con-select">
                                                        {grupo.grupo}
                                                        <select
                                                            value={motivoSeleccionado[i] || ""}
                                                            onChange={(e) =>
                                                                setMotivoSeleccionado(prev => ({ ...prev, [i]: e.target.value }))
                                                            }
                                                            className="motivo-select"
                                                        >
                                                            {options.map(opt => (
                                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                ) : (
                                                    grupo.grupo
                                                )}
                                            </td>
                                        </tr>

                                        {grupo.registros
                                            .filter(item => {
                                                const selectedMotivo = motivoSeleccionado[i] || "";
                                                if (grupo.grupo === "Clientes sin interés" && selectedMotivo) {
                                                    if (mostrar === "S") {
                                                        return item.motivo === selectedMotivo;
                                                    }
                                                    if (mostrar === "C") {
                                                        return item.tipo === selectedMotivo || selectedMotivo === "";
                                                    }
                                                }
                                                return true; // los demás registros siempre se muestran
                                            })
                                            .map((item, index) => (
                                                <tr key={index}>
                                                    <td className="ta-center">{mostrar === "C" ? item.orden : mostrar === "S" ? item.id_registro : item.id_garantia}</td>
                                                    <td>{capitalizePalabras(item.sucursal)}</td>
                                                    {(mostrar === "C") && (
                                                        <td className="ta-center">{item.idcliente_equip ? item.idcliente_equip : 'Sin registrar'}</td>
                                                    )}
                                                    <td>{capitalizePalabras(item.cliente)}</td>
                                                    <td className="celda-whatsapp">
                                                        {/* {mostrar === "C"
                                                            ? item.whatsapp
                                                            : item.contacto === "N"
                                                                ? "Sin registrar"
                                                                : item.contacto} */}

                                                        <div className="whatsapp">
                                                            {mostrar === "C" ? (
                                                                <div className="editar-numero">
                                                                    {item.whatsapp}
                                                                    <span
                                                                        onClick={() =>
                                                                            handleOpenModalContacto(item.idcliente)
                                                                        }
                                                                    >
                                                                        <EditIcon />
                                                                    </span>
                                                                </div>

                                                            ) : item.contacto === "N" ? (
                                                                <div
                                                                    className="boton-agregar-contacto"
                                                                    onClick={() =>
                                                                        handleOpenModalContacto(item.idcliente, item.orden, item.id_garantia, item.id_registro)
                                                                    }
                                                                >
                                                                    <AddCircleOutlineIcon /> Agregar
                                                                </div>
                                                            ) : (
                                                                <div className="editar-numero">
                                                                    {item.contacto}
                                                                    <span
                                                                        onClick={() =>
                                                                            handleOpenModalContacto(item.idcliente, 0, item.id_garantia, item.id_registro)
                                                                        }
                                                                    >
                                                                        <EditIcon />
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>


                                                    </td>

                                                    {mostrar === "C" ? (
                                                        <td className="ta-left">{capitalizePalabras(item.vendedor)}</td>
                                                    ) : (
                                                        <>
                                                            <td className="ta-center">{item.num_serie}</td>
                                                            <td className="ta-center">{item.modelo}</td>
                                                        </>
                                                    )}

                                                    {(mostrar === "C" || mostrar === "S") && (
                                                        <td className="ta-center">{item.fecha_envio}</td>
                                                    )}

                                                    {/* Estado */}
                                                    <td>
                                                        {mostrar === "C"
                                                            ? (
                                                                item.tipo === "CI"
                                                                    ? "Cliente con interés"
                                                                    : item.tipo === "SI"
                                                                        ? "Cliente sin interés"
                                                                        : item.tipo === "ER"
                                                                            ? "Esperando respuesta"
                                                                            : item.estado
                                                            )
                                                            : (
                                                                item.estado.startsWith("RL")
                                                                    ? "Respuesta escrita: " + item.estado.substring(2).trim()
                                                                    : item.estado === "CI"
                                                                        ? "Cliente con interés"
                                                                        : item.estado === "SI"
                                                                            ? "Cliente sin interés"
                                                                            : item.estado === "ER"
                                                                                ? "Esperando respuesta"
                                                                                : item.estado
                                                            )
                                                        }
                                                    </td>


                                                    {/* Motivo */}
                                                    {(mostrar === "S" || mostrar === "C") && (
                                                        <td>
                                                            {(() => {
                                                                const code = mostrar === "S" ? item.motivo : item.tipo;
                                                                switch (code) {
                                                                    case "TE": return "Tiempo de entrega";
                                                                    case "PR": return "Precio de la refacción";
                                                                    case "AB": return "Atención brindada";
                                                                    case "NN": return "No se necesitó";
                                                                    case "PS": return "Precio del servicio";
                                                                    case "DC": return "Disponibilidad de crédito";
                                                                    case "CI": return "";
                                                                    case "ER": return "";
                                                                    case "RL": return "";
                                                                    default: return code; // muestra el código si no hay texto definido
                                                                }
                                                            })()}
                                                        </td>
                                                    )}


                                                    <td className="ta-center">
                                                        {item.facturado === "S" ? (
                                                            <CheckCircleIcon sx={{ color: "#5aa05b !important" }} />
                                                        ) : (
                                                            <RemoveCircleIcon sx={{ color: "#7b7b7b !important" }} />
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                    </React.Fragment>
                                ))}
                            </tbody>


                        </table>

                    </div>
                </div>
            )}
        </PlantillaScreen>
    );
};
